import React, { useState, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import Input from "../../../../../../components/forms-fields/Input";
import { addHealthAppointments } from "../../../../../../schemas";
import { useFormik } from "formik";
import ReactDOMServer from 'react-dom/server';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { UPDTE_CARE_PLAN_URL, ADMIN_ID } from "../../../../../../env";
import {
  postRecords,
  catchAsync,
  isSuccess,
  toastSuccessMessages,
  toastErrorMessages,
} from "../../../../../../helper/helper";
import CustomSelect from "../../../../../../components/forms-fields/CustomSelectStaffMembers";
import TextArea from "../../../../../../components/forms-fields/TextArea";
import moment from "moment";
import { Link, useLocation } from "react-router-dom";
import Layout from "../../../../../../components/layouts/Layout";
import SelectBox from "../../../../../../components/forms-fields/SelectBox";

function EditHealthAppointments() {
  const location = useLocation();
  const carePlanDetail = location?.state ? location?.state?.editCarePlanDetail[0] : null;
  
  const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);
  const [isToastAddCarePlans, setIsToastAddCarePlans] = useState(false);


  const appointmentWithRef = useRef(null);
  const reasonForAppointmentRef = useRef(null);
  const commentsRef = useRef(null);
  useEffect(() => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = carePlanDetail?.noteDetails || '';

    appointmentWithRef.current.innerText = tempDiv.querySelector('#appointmentWithData')?.innerText || '';
    reasonForAppointmentRef.current.innerText = tempDiv.querySelector('#reasonForAppointmentData')?.innerText || '';
    commentsRef.current.innerText = tempDiv.querySelector('#commentsData')?.innerText || '';
  }, [carePlanDetail?.noteDetails]);


  const [suFormData, setSuFormData] = useState({

    addedby: carePlanDetail?.addedby?._id,
    reasonForAppointment: '',
    appointmentWith: '',
    comments: '',
    eventDateTime: carePlanDetail?.eventDateTime,
  });
  useEffect(() => {
    setValues(prevState => ({
      ...prevState,
      reasonForAppointment: reasonForAppointmentRef.current?.innerText || '',
      appointmentWith: appointmentWithRef.current?.innerText || '',
      comments: commentsRef.current?.innerText || '',
    }));
  }, [carePlanDetail?.noteDetails]);

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
  } = useFormik({
    initialValues: suFormData,
    validationSchema: addHealthAppointments,
    onSubmit: async (values) => {
      try {
        

        setIsSubmitButtonClicked(true);
        await postAddCarePlansFormData(values);
      } catch (error) {
        
      }
    },
  });

  const processPostRecords = (method, data) => {
    
    if (data?.status !== isSuccess) {
      setIsToastAddCarePlans(true);
      toastErrorMessages(toast.error, data?.message, "", 10, 10);
      setIsSubmitButtonClicked(false);

    } else if (
      method === "postAddCarePlansFormData" &&
      data?.status === isSuccess
    ) {
      setIsToastAddCarePlans(true);
      toastSuccessMessages(toast.success, data?.message, "/care-plan/general-notes", 10, 10);
      setIsSubmitButtonClicked(false);
    }
  };

  const postAddCarePlansFormData = catchAsync(async (req, res) => {
    const noteDetailsString = ReactDOMServer.renderToString(htmlData);
    const updateValues = {
      carePlanid: carePlanDetail?._id,
      userId: carePlanDetail?.userId,
      noteType: carePlanDetail?.noteType,
      title: values?.comments,
      flag: carePlanDetail?.flag,
      noteDetails: carePlanDetail?.noteDetails,
      eventDateTime: moment(values.eventDateTime).valueOf(),

      addedby: ADMIN_ID,
      isHTML: true,
      noteDetails: noteDetailsString,
    }

    
    const response = await postRecords(UPDTE_CARE_PLAN_URL, updateValues);
    
    setIsSubmitButtonClicked(false);
    processPostRecords("postAddCarePlansFormData", response);
  });



  const handleInputChangePrevFields = (e) => {
    const { name, value } = e.target;
    setSuFormData({
      ...suFormData,
      [name]: value
    });
    handleChange(e);
    handleBlur(e);
  };


  const [htmlData, setHtmlData] = useState("")
  useEffect(() => {
    setHtmlData(
      <>
        <div className="col-md-6">
          <p><strong>Appointment with: </strong><span id="appointmentWithData">{values?.appointmentWith} </span></p>
        </div>
        <div className="col-md-6">
          <p><strong>Reason for appointment: </strong><span id="reasonForAppointmentData">{values?.reasonForAppointment}</span></p>
        </div>
        <div className="col-md-12">
          <p><strong>Comments: </strong><span id="commentsData">{values?.comments}</span></p>
        </div>
      </>
    );
  }, [values]);

  const appointmentWithOptions = [
    { value: "GP", label: "GP" },
    { value: "CAMHS", label: "CAMHS" },
    { value: "Psychologist", label: "Psychologist" },
    { value: "A&E", label: "A&E" },
    { value: "Sexual Health", label: "Sexual Health" },
    { value: "Social Worker", label: "Social Worker" },
    { value: "Other", label: "Other" },
  ];
  return (
    <>

      <Layout pageTitleText="Notes">
        <div className="incidents consentCapacityAddNew">
          <div className="mainContent ">
            <div className="mainContentText">
              <h3>Edit Health Appointments note</h3>
              <form onSubmit={handleSubmit}>
                <div className="formBlockContent">
                  <div className="row">


                    <div className="col-md-4">
                      <Input
                        type="datetime-local"
                        id="eventDateTime"
                        name="eventDateTime"
                        value={moment(values?.eventDateTime).format('YYYY-MM-DDTHH:mm')}
                        onChange={handleInputChangePrevFields}
                        onBlur={handleBlur}
                        labelText="Date / Time"
                        customError={touched?.eventDateTime && errors?.eventDateTime}
                        errorMessage={errors?.eventDateTime}
                        erroClass={
                          touched?.eventDateTime && errors?.eventDateTime
                            ? "validationError"
                            : ""
                        }
                        requiredStar={true}
                      />

                    </div>
                    <div className="col-md-4">
                      <SelectBox
                        id={"appointmentWith"}
                        name={"appointmentWith"}
                        value={values?.appointmentWith}
                        onChange={handleChange}
                        options={appointmentWithOptions}
                        labelText="Appointment with"
                        requiredStar={true}
                      />

                    </div>
                    <div className="col-md-4">
                      <Input
                        type="text"
                        id="reasonForAppointment"
                        name="reasonForAppointment"
                        value={values?.reasonForAppointment}
                        onChange={handleInputChangePrevFields}
                        onBlur={handleBlur}
                        labelText="Reason for appointment"
                        customError={touched?.reasonForAppointment && errors?.reasonForAppointment}
                        errorMessage={errors?.reasonForAppointment}
                        erroClass={
                          touched?.reasonForAppointment && errors?.reasonForAppointment
                            ? "validationError"
                            : ""
                        }
                        requiredStar={true}
                      />

                    </div>
                    <div className="col-md-12">

                      <TextArea
                        id="comments"
                        name="comments"
                        value={values?.comments}
                        onChange={handleInputChangePrevFields}
                        onBlur={handleBlur}
                        labelText="Comments"
                        rows="3"
                        className="mb-0"
                        customError={touched?.comments && errors?.comments}
                        errorMessage={errors?.comments}
                        erroClass={
                          touched?.comments && errors?.comments
                            ? "validationError"
                            : ""
                        }
                        requiredStar={true}
                      />
                    </div>

                  </div>
                </div>

                <div className="formActionButtons">
                  <Link
                    to={"/care-plan/general-notes"}
                    className="btn btn-sm btn-outline-primary"
                  >
                    Back
                  </Link>

                  {isSubmitButtonClicked ? (
                    <Button
                      // onClick={subModalAddCarePlans}
                      className="btn-sm"
                      variant="primary"
                      disabled
                    >
                      Loading...
                    </Button>
                  ) : (
                    <Button className="btn-sm" variant="primary" type="submit">
                      Submit
                    </Button>
                  )}
                </div>
              </form>
              <div className="referenceDiv">
                <div ref={appointmentWithRef}></div>
                <div ref={reasonForAppointmentRef}></div>
                <div ref={commentsRef}></div>
              </div>
              {isToastAddCarePlans && <ToastContainer />}
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}

export default EditHealthAppointments